import { useMemo } from 'react'
import { useNavigate, Link } from 'react-router';
import { QuickAddExpense } from '../components/quickAddExpense'
import { useAppSelector } from '../hooks/reduxToolkit';
import { selectTodos } from '../reduxToolkit/selectors/todos';
import { byTodoDueDateAscending } from '../../lib/util/sort';
import { useTodoCompletion } from '../hooks/todos/useTodoCompletion';
import { formatDateInTimeZone } from '../../lib/formatDateInTimeZone';
import { endOfYear, startOfDay } from 'date-fns';
import { Tooltip } from '../components/tooltip';
import { useTour } from './homepage/tour';
import { useReturnTo } from '../hooks/useReturnTo';
import { useSubscriptionAccess } from '../hooks/useSubscriptionAccess';

import './homepage.scss'

export function Homepage() {
  const navigate = useNavigate()
  const { isReadOnly } = useSubscriptionAccess()

  useTour()
  useReturnTo()

  return <div className='homepage'>
    <div className="row">
      <div className="col-12 homepage__header">
        <h1>HealthShare Reimbursement Tracker</h1>
        <p>
          Automatically convert your itemized bills to documents ready to submit.
        </p>
      </div>

      <div className="col-12 col-xl-8">
        <QuickAddExpense
          allowNewIncident={true}
          disabled={isReadOnly}
          onInserted={(expense) => {
          if (expense.incident_id) {
            navigate(`/incidents/${expense.incident_id}`, { state: { expense_id: expense.id } })
          } else {
            navigate(`/expenses`, { state: { expense_id: expense.id } })
          }
        }} />
      </div>

      <div className='col-12'>
        <HomepageNextSteps />
      </div>
    </div>
  </div>
}

export function HomepageNextSteps() {
  const today = useMemo(() => startOfDay(new Date(Date.now())).toISOString(), [])
  const eoy = useMemo(() => endOfYear(new Date(Date.now())).toISOString(), [])

  const todos = useAppSelector(selectTodos())
  const totalTodos = todos.length
  const sortedTodos = todos.sort(byTodoDueDateAscending).slice(0, 3)
  const [onClick, _, modal] = useTodoCompletion()

  if (!todos.length) {
    return null
  }

  return <div className='homepage__next-steps'>
    <h3>Next Steps</h3>
    <div className='homepage__next-steps__todo-list'>
      <ol>
        {sortedTodos.map((t) => {
          const isPast = t.has_due_date && t.due_date && t.due_date < today
          const showYear = t.has_due_date && t.due_date && t.due_date > eoy
          
          return <li
              key={t.id}
              className='homepage__next-steps__todo-list-item'
              onClick={() => onClick(t)}>
            <button className='btn btn-link'>
              {t.title}
            </button>

            {t.has_due_date && <>
                <br className='d-md-none'/>&nbsp;{isPast && t.due_date ?
                  <span className='text-danger'><Tooltip tooltip={`This was due on ${formatDateInTimeZone(t.due_date, { format: 'MMMM d, yyyy' })}`}>past due!</Tooltip></span> :
                  <span>&nbsp;{
                    t.due_date ?
                      `before ${formatDateInTimeZone(t.due_date, { format: showYear ? 'MMMM d, yyyy' : 'MMMM d' })}` :
                      'ASAP'}
                  </span>}
              </>}
          </li>
        })}

      </ol>
      {totalTodos > todos.length &&
        <Link to="/todos" className='btn btn-link float-end'>more...</Link>}
    </div>

    {modal}
  </div>
}
